import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, InputLabel, Autocomplete, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import trabajadorService from "../services/trabajadorService";
import moment from 'moment';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setEntity, setData, add, remove, setTerapeutas, setTiposCargos, setEstados
    , setValidations, activeValidations
} from '../redux/therapyTherapistSlice'
import DialogYesNo from './DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';

const TherapyTherapist = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const idFilialTerapia = useSelector((state) => state.therapy?.entity?.idFilial) || 0;
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const idFilialEfectiva = idFilialTerapia || idFilialUsuario || 0;
    const entity = useSelector((state) => state.therapyTherapist.entity)
    const defaultEntity = useSelector((state) => state.therapyTherapist.defaultEntity)
    const listTerapeutas = useSelector((state) => state.therapyTherapist.listTerapeutas)
    const listTiposCargos = useSelector((state) => state.therapyTherapist.listTiposCargos)
    const listEstados = useSelector((state) => state.therapyTherapist.listEstados)
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    const [numeroDocumentoFocus, setNumeroDocumentoFocus] = useState(null);
    const validate = useSelector((state) => state.therapyTherapist.validationActive);
    const dispatch = useDispatch();

    var validation = {
        AtLeastOneRow: {
            error: entity.length == 1
                &&
                (
                    entity[0].idTerapeuta == 0
                    || entity[0].idTipoCargo == 0
                    || entity[0].fechaInicio == null
                ),
            message: "Debe haber por lo menos un terapeuta",
        },
    }

    const setItemValue = (numero, name, value) => {
        dispatch(setData({numero: numero, name: name, value: value}))
    }

    const fecthEntity = useCallback(async () => {
        const response = await api.get("/Terapia/GetsTerapiaTerapeutaView?idTerapia=" + params.id)
            .catch((err) => {
                console.log("Err: ", err)
            });

            console.log(response)
        
        if (response.data.data == null || response.data.data.length == 0)
            dispatch(setEntity(defaultEntity));
        else
            dispatch(setEntity(response.data.data));
    }, [])
    const fetchTerapeutas = useCallback(async (idFilial = idFilialEfectiva) => {
        if (!idFilial || idFilial <= 0) {
            dispatch(setTerapeutas([]));
            return;
        }
        const data = await trabajadorService.getsTerapeutas("", true, true, idFilial)
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        dispatch(setTerapeutas(data || []));
    }, [idFilialEfectiva, dispatch])
    const fetchTiposCargos = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=53")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setTiposCargos(response.data.data));
    }, [])
    const fetchEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setEstados(response.data.data));
    }, [])

    useEffect(() => {
        fecthEntity();
        fetchTiposCargos();
        fetchEstados();
    }, [])

    useEffect(() => {
        fetchTerapeutas(idFilialEfectiva);
    }, [idFilialEfectiva, fetchTerapeutas]);

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    useEffect(() => {
        
    }, [entity])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deleteEntity = async () => {
        await api.delete("/Terapia/DeleteTerapiaTerapeuta?idTerapia="
                + params.id + "&numero=" + selectNumero)
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(remove(selectNumero));
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Terapeutas (" + (entity != null ? entity.length : 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly} size="small" aria-label="Agregar Terapeuta" style={{height: 10}} onClick={() => {
                    dispatch(add(params.id));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(entity)} */}
                {/* {JSON.stringify(numeroDocumentoExistente)} */}
                <Table size="small">
                    <TableBody>
                        {entity.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell sx={{ px: 0.5, py: 1 }}>
                                    <Grid container spacing={1} padding={0} sx={{ alignItems: "center", maxWidth: { lg: 1040 } }}>
                                        <Grid item xs={12} md={2.5} lg={2.5}>
                                            <FormControl required fullWidth error={validate.terapeuta && validation.terapeuta.error}>
                                                <Autocomplete
                                                    name="idTerapeuta"
                                                    value={listTerapeutas.find((x) => x.id === row.idTerapeuta) || (row.terapeuta ? { id: row.idTerapeuta || 0, descripcion: row.terapeuta } : null)}
                                                    inputValue={row.terapeuta == null ? "" : row.terapeuta}
                                                    onInputChange={(event, newInputValue, reason) => {
                                                        setItemValue(row.numero, "terapeuta", newInputValue || "");
                                                        if (reason === "clear" || !newInputValue) {
                                                            setItemValue(row.numero, "idTerapeuta", 0);
                                                        }
                                                    }}
                                                    onChange={(event, newValue) => {
                                                        setItemValue(row.numero, "idTerapeuta", newValue == null ? 0 : newValue.id);
                                                        setItemValue(row.numero, "terapeuta", newValue == null ? "" : newValue.descripcion);
                                                    }}
                                                    options={listTerapeutas}
                                                    autoHighlight
                                                    disabled={isReadOnly || (row.id > 0 && Boolean(row.tieneSesiones))}
                                                    getOptionLabel={(option) => (typeof option === "string" ? option : (option?.descripcion || ""))}
                                                    isOptionEqualToValue={(option, value) => option?.id === (value?.id ?? value)}
                                                    renderOption={(props, option) => {
                                                        return (
                                                            <li {...props} key={option.id}>
                                                            {option.descripcion}
                                                            </li>
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Terapeuta"
                                                            variant="outlined"
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                autoComplete: 'new-password',
                                                            }}
                                                        />
                                                    )}
                                                    size="small"
                                                />
                                                <HelperText>{Boolean(row.tieneSesiones) ? "Bloqueado por sesiones registradas" : (validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : "")}</HelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2} lg={2}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-tipocargo">Tipo Cargo</InputLabel>
                                                <Select
                                                    //native={!diasSemana.length == 0}
                                                    native
                                                    //defaultValue={0}
                                                    label="Tipo Cargo"
                                                    value={row.idTipoCargo}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idTipoCargo", event.target.value)
                                                        setItemValue(row.numero, "tipoCargo", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idTipoCargo',
                                                        id: 'input-tipocargo',
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {listTiposCargos.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                                {/* <HelperText>
                                                    {validate.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                                                </HelperText>
                                                <HelperText>
                                                    {validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                                                </HelperText> */}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2.5} lg={2.5}>
                                            <TextField
                                                required
                                                name="fechaInicio"
                                                label="Fecha Inicio"
                                                fullWidth
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                //defaultValue={moment()}
                                                value={moment(row.fechaInicio).format('yyyy-MM-DD')}
                                                onChange = {(e) => {setItemValue(row.numero, "fechaInicio", e.target.value == "" ? moment().format('yyyy-MM-dd') : e.target.value)}}
                                                error={validate.fechaInicio && validation.fechaInicio.error}
                                                helperText={validate.fechaInicio && validation.fechaInicio.error ? validation.fechaInicio.message : ""}
                                                disabled={isReadOnly}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2.5} lg={2.5}>
                                            <TextField
                                                name="fechaFin"
                                                label="Fecha Fin"
                                                fullWidth
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                //defaultValue={moment()}
                                                value={moment(row.fechaFin).format('yyyy-MM-DD')}
                                                onChange = {(e) => {setItemValue(row.numero, "fechaFin", e.target.value == "" ? null : e.target.value)}}
                                                error={validate.fechaFin && validation.fechaFin.error}
                                                helperText={validate.fechaFin && validation.fechaFin.error ? validation.fechaFin.message : ""}
                                                disabled={isReadOnly}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={8} sm={4} md={1.5} lg={1.5}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                                <Select
                                                    native
                                                    label="Estado"
                                                    value={row.idEstado}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idEstado", event.target.value)
                                                        setItemValue(row.numero, "estado", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idEstado',
                                                        id: 'input-estado',
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {listEstados.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4} sm={2} md={1} lg={1} sx={{ display: "flex", alignItems: "center" }}>
                                            <IconButton aria-label="delete" disabled={isReadOnly || (row.id > 0 && Boolean(row.tieneSesiones))} onClick={() => {
                                                if (row.id > 0) {
                                                    setSelectId(row.id);
                                                    setSelectNumero(row.numero);
                                                    setOpenDialogDelete(true);
                                                }
                                                else {
                                                    dispatch(remove(row.numero));
                                                }

                                            }}>
                                                <IconDelete />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        (validate.AtLeastOneRow && validation.AtLeastOneRow.error)
                    }>

                    <HelperText>
                        {validate.AtLeastOneRow && validation.AtLeastOneRow.error ? validation.AtLeastOneRow.message : ""}
                    </HelperText>
                </FormControl>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deleteEntity}
                setNo={() => { return }}
                titulo={"Borrar terapeuta"}
                texto={"Esta seguro de borrar el terapeuta?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default TherapyTherapist;
